"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientEditPendingQuerySchema = exports.requestPatientEditSchema = exports.previewPatientEditSchema = void 0;
/**
 * PATIENT EDIT REQUEST — front desk asks for a registered patient's details to be changed; a verifier and an approver decide it (desk,
 * 2026-10-07: "when user clicks edit under patient info this should go under the modification flow… request should be send by front desk
 * users, every field, retire direct save").
 *
 * THE BODY IS THE SAME SHAPE the retired direct save took (`updateDemographicsRequestSchema`): the patient, the lock version the clerk
 * was looking at, and ONLY the fields that differ (absent = leave alone, null = clear). A reason is now required — it is what the verifier
 * and approver read. Nothing changes on the patient until approval.
 */
const zod_1 = require("zod");
const demographics_request_1 = require("./demographics.request");
/** What the preview takes: the request without the reason (the clerk checks the change before writing why). */
exports.previewPatientEditSchema = demographics_request_1.updateDemographicsRequestSchema.omit({ reason: true });
exports.requestPatientEditSchema = demographics_request_1.updateDemographicsRequestSchema.extend({
    reason: zod_1.z.string().trim().min(3, 'A reason is required').max(500),
});
exports.patientEditPendingQuerySchema = zod_1.z.object({ patientId: zod_1.z.string().uuid() });
//# sourceMappingURL=financial-patient-correction.request.js.map